export class PaginationConfig {
    public static readonly PAGE_SIZE = 10;
    public static readonly PAGE_LINK_SIZE = 5;
    public static readonly ORDER_PAGE_SIZE = 9;
}
  